import axiosPost from '../axiosPost';

export const endUserGet = async (arg) => {
    const { params } = arg

    const body = {
        "service": "EndUserBOListGet",
        "params": params ? params : {}
    }

    try {
        const result = await axiosPost('Y', body, arg);
        return {
            data: result.data?.result,
            total: result.data?.status?.id
        }
    } catch (err) {
        console.log(err)
    }
};